// extracted by mini-css-extract-plugin
module.exports = {"container":"ExternalReferences_container__H2qIT","subTitle":"ExternalReferences_subTitle__of6mA","info":"ExternalReferences_info__31MaE"};